import axios from "axios";
//hh
const BASE_URL = 'https://stockpos.tech';
export default axios.create({
    baseURL:BASE_URL
})
//test
export const axiosPrivate= axios.create({
    baseURL:BASE_URL,
    headers : {'Content-Type':'application/json'},
    withCredentials:true
})
